// 3rd Party References
import * as React from 'react';

// Utility References
import { Handler } from '../../../IndexOfActions';
//import {  } from '../../../IndexOfComponents';
//import {  } from '../../../IndexOfEnums';
//import {  } from '../../../IndexOfHelpers';
//import {  } from '../../../IndexOfInterfaces';
import { IGridFilterContext } from '../../../IndexOfModels';
//import {  } from '../../../IndexOfServices';

// Local References
import ClearButton from './ClearButton';

type UpdateExpr = <TFilter, TValue>(filter: TFilter, value: TValue) => void;

interface ITimeFilterProps extends React.Props<TimeFilter> {
    gridFilterContext: IGridFilterContext;
    isDisabled?: boolean;
    key: string | number;
    label: string;
    updateExpr: UpdateExpr;
    value: string;
}

export default class TimeFilter extends React.Component<ITimeFilterProps, {}> {

    private checkTimeValue = (inputValue: string): string => {

        const timeFormatRegEx: RegExp = /([01]\d|2[0-3]):([0-5]\d)/;
        return timeFormatRegEx.test(inputValue) ? inputValue : null;
    }

    private handleChange = (updateFunc: Handler.StringValue) => (event: React.FormEvent<HTMLInputElement>): void => {

        const inputValue = (event.target as HTMLInputElement).value;
        if (inputValue == null) {
            this.reset(updateFunc)();
        }

        const newValue = this.checkTimeValue(inputValue);

        if (newValue != null) {
            updateFunc(newValue);
        }
    }

    private reset = (updateFunc: Handler.StringValue) => () => {

        updateFunc(null);
    }

    componentDidUpdate() {
        if (this.props.value == null) {
            (this.refs.timeInput as HTMLInputElement).value = null;
        }
    }

    render() {

        const { gridFilterContext, isDisabled, label, updateExpr, value } = this.props;

        const updateFunc = gridFilterContext.filterHandler(updateExpr);

        const inputProps = {
            className: 'form-control grid-filter',
            disabled: isDisabled,
            onChange: this.handleChange(updateFunc),
            placeholder: label,
            ref: 'timeInput'
        };

        if (!!value) {
            inputProps.className += ' active';
        }

        return (
            <th>
                <div className="input-group">
                    <input {...inputProps} />
                    <span className="input-group-btn">
                        <ClearButton isDisabled={isDisabled} resetClickHandler={this.reset(updateFunc)} value={value} />
                    </span>
                </div>
            </th>
        );
    }
}
